import React, {useEffect, useState} from 'react';

import styled from 'styled-components';
import { Button, Input, Table, Space } from 'antd';
import { toast } from 'react-hot-toast';

import SiteAdmin from '../components/SiteAdmin';
import Page from 'components/Page';
import withAdminOnly from '../components/AdminOnly';
import { AuthAPI, useGetApi, useMutateApi } from 'providerSite/api';


const Container = styled.div`
  width: 100%;
  min-height: 70vh;
`;

const WhitelistingPage = () => {
  const [ value, setValue ] = useState();
  const [ recordId, setRecordId ] = useState();

  const { data = [], isLoading } = useGetApi(AuthAPI.GET_WHITELIST);

  const postMutation = useMutateApi(AuthAPI.POST_WHITELIST, 'POST', {
    invalidation: {exact: true},
    onSuccess: () => {
      toast.success('Successfully added to the whitelist');
    },
  });

  const deleteMutation = useMutateApi(AuthAPI.DELETE_WHITELIST, 'DELETE', {
    params: {
      id: recordId,
    },
    invalidation: [
      {
        endpoint: AuthAPI.GET_WHITELIST,
        params: {},
      },
    ],
    onSuccess: () => {
      toast.success('Successfully added to the whitelist');
      setRecordId(null);
    },
  });

  useEffect(() => {
    if (!recordId) return;
    deleteMutation.mutate({});

  }, [recordId]);


  const columns = [
    {
      title: 'Whitelist Type',
      dataIndex: 'type',
      key: 'type',
    },
    {
      title: 'Actioned For',
      dataIndex: 'actionFor',
      key: 'actionFor',
    },
    {
      title: 'Phone Number',
      dataIndex: 'value',
      key: 'value',
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <Button
            danger
            onClick={() => setRecordId(record.id)}
            loading={recordId === record.id && deleteMutation.isLoading}
          >
            Delete
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <Page title="Whitelisting">
      <SiteAdmin>
        <Container>
          <Input.Group compact>
            <Input
              style={{
                width: '300px',
              }}
              placeholder="Phone number"
              onChange={e => setValue(e.target.value)}
              allowClear
            />
            <Button
              type="primary"
              onClick={() => postMutation.mutate({phone: value})}
              loading={postMutation.isLoading}
            >
              Whitelist
            </Button>
          </Input.Group>
          <Table style={{marginTop: '20px'}} loading={isLoading} dataSource={data} columns={columns} />
        </Container>
      </SiteAdmin>
    </Page>
  );
};

export default withAdminOnly(WhitelistingPage);
